import styled, { css } from 'styled-components'

export const DotPulseLoader = styled.div`
    ${props => {
        const { loaderColor } = props
        const color = loaderColor || '#fff'
        return css`
            position: relative;
            left: -9999px;
            width: 10px;
            height: 10px;
            border-radius: 5px;
            background-color: ${color};
            color: ${color};
            box-shadow: 9999px 0 0 -5px ${color};
            animation: dotPulse 1.5s infinite linear;
            animation-delay: 0.25s;

            :before,
            :after {
                content: '';
                display: inline-block;
                position: absolute;
                top: 0;
                width: 10px;
                height: 10px;
                border-radius: 5px;
                background-color: ${color};
                color: ${color};
                margin: 0px -5px;
            }

            :before {
                box-shadow: 9984px 0 0 -5px ${color};
                animation: dotPulseBefore 1.5s infinite linear;
                animation-delay: 0s;
            }

            :after {
                box-shadow: 10014px 0 0 -5px ${color};
                animation: dotPulseAfter 1.5s infinite linear;
                animation-delay: 0.5s;
            }

            @keyframes dotPulseBefore {
                0% {
                    box-shadow: 9984px 0 0 -5px ${color};
                }
                30% {
                    box-shadow: 9984px 0 0 2px ${color};
                }
                60%,
                100% {
                    box-shadow: 9984px 0 0 -5px ${color};
                }
            }

            @keyframes dotPulse {
                0% {
                    box-shadow: 9999px 0 0 -5px ${color};
                }
                30% {
                    box-shadow: 9999px 0 0 2px ${color};
                }
                60%,
                100% {
                    box-shadow: 9999px 0 0 -5px ${color};
                }
            }

            @keyframes dotPulseAfter {
                0% {
                    box-shadow: 10014px 0 0 -5px ${color};
                }
                30% {
                    box-shadow: 10014px 0 0 2px ${color};
                }
                60%,
                100% {
                    box-shadow: 10014px 0 0 -5px ${color};
                }
            }
        `
    }}
`
